// removed by extract-text-webpack-plugin
module.exports = {"records_table":"records_table__1U3mu","row":"row__1dGCh","column_headings":"column_headings__UTRs7","label_cell":"label_cell__1zgVs","value_cell":"value_cell__2xuni","datetime_cell":"datetime_cell__HUrSh","date":"date__3Em8D","time":"time__2HkKb"};


//////////////////
// WEBPACK FOOTER
// ./components/records-table/style.scss
// module id = wzQq
// module chunks = 6